/* Action-only tracking. Uses the existing Google tag; never configures page views. */
(() => {
  'use strict';
  if (window.__wcLeadTrackingLoaded) return;
  window.__wcLeadTrackingLoaded = true;
  const destination = 'G-RQ941S6G6L';
  const quoteOrigin = 'https://zlite-online-quote-form.onrender.com';
  const quoteEvents = new Set(['quote_estimate_generated', 'appointment_request_sent']);
  const seen = new Set();
  let pending = [], retry = null;

  function allowed() {
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; }
    catch (_) { return false; }
  }
  function flush() {
    retry = null;
    if (!allowed()) { pending = []; return; }
    pending = pending.filter(item => Date.now() - item.time < 10000);
    if (typeof window.gtag === 'function') {
      const batch = pending; pending = [];
      for (const item of batch) {
        try {
          window.gtag('event', item.name, {
            send_to: destination,
            page_location: window.location.origin + window.location.pathname,
            page_referrer: '',
            transport_type: 'beacon'
          });
        } catch (_) { /* Analytics must never interrupt an enquiry. */ }
      }
    } else if (pending.length) { retry = setTimeout(flush, 250); }
  }
  function track(name) {
    if (!allowed() || window.Shopify?.designMode) return;
    if (pending.length < 20) pending.push({ name, time: Date.now() });
    if (retry === null) flush();
  }
  document.addEventListener('visitorConsentCollected', () => {
    if (!allowed()) { pending = []; clearTimeout(retry); retry = null; }
  });
  // Load Shopify's consent API without changing the visitor's consent choice.
  if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
  }
  window.addEventListener('message', event => {
    const data = event.data;
    if (event.origin !== quoteOrigin || !data || data.type !== 'zlite-quote:analytics') return;
    const frame = document.querySelector('iframe[data-quote-frame]');
    if (!frame || event.source !== frame.contentWindow || !quoteEvents.has(data.name)) return;
    if (typeof data.id !== 'string' || !/^[a-zA-Z0-9-]{1,80}$/.test(data.id) || seen.has(data.id)) return;
    seen.add(data.id);
    if (seen.size > 500) seen.delete(seen.values().next().value);
    track(data.name);
  });
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (!link) return;
    const href = link.getAttribute('href') || '';
    if (/^mailto:/i.test(href)) track('contact_email_click');
    else if (/^tel:/i.test(href)) track('contact_phone_click');
  });

  if (/^\/pages\/contact\/?$/.test(window.location.pathname)) {
    let attempts = 0;
    function attachContactObserver() {
      const host = document.querySelector('[data-forms-id="forms-root-1173973"] shopify-forms-embed');
      const root = host?.shadowRoot;
      if (!root) {
        if (++attempts < 120) setTimeout(attachContactObserver, 250);
        return;
      }
      let submitted = false, finished = false;
      root.addEventListener('submit', event => {
        if (event.target?.matches('form[data-testid="form"]') &&
            root.querySelector('[data-current-step="form"]')) submitted = true;
      }, true);
      const observer = new MutationObserver(() => {
        if (!submitted || finished || !host.isConnected) return;
        const success = root.querySelector('[data-current-step="success"] [data-testid="banner-success"]');
        if (!success) return;
        finished = true;
        observer.disconnect();
        track('contact_form_success');
      });
      observer.observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['data-current-step'] });
    }
    attachContactObserver();
  }
})();
